<template>
  <div class="add-product">
    <!-- 表单内容 -->
    <div class="form-content">
      <el-form>
        <el-row>
          <el-col :span="12">
            <el-form-item label="语言" required>
              <el-select v-model="currentData.language_code" placeholder="请选择语言">
                <el-option v-for="item in languageList" :key="item.code" :label="item.name" :value="item.code" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- 产品分类 -->
            <el-form-item label="品类" required>
              <el-select v-model="currentData.category_id" placeholder="请选择品类">
                <el-option v-for="category in categoryList" :key="category.id" :label="getCategoryName(category)" :value="category.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 产品名 -->
        <el-form-item label="产品名" required>
          <el-input v-model="currentData.name" placeholder="请输入产品名" />
        </el-form-item>
        <!-- 产品副标题 -->
        <el-form-item label="副标题">
          <el-input v-model="currentData.sub_title" placeholder="请输入产品副标题/简短描述" />
        </el-form-item>

        <!-- 产品主图 -->
        <el-form-item label="产品主图" required>
          <div class="upload-container">
            <upload
              :path="'product'"
              :images="currentData.image ? currentData.image : ''"
              :multiple="false"
              :num="1"
              @success="handleImageSuccess"
              @remove="handleImageRemove"
            />
          </div>
        </el-form-item>

        <!-- 产品多图 -->
        <el-form-item label="产品相册">
          <div class="upload-container">
            <upload
              :path="'product'"
              :images="currentData.images"
              :multiple="true"
              :num="9"
              @success="handleImagesSuccess"
              @remove="handleImagesRemove"
            />
          </div>
          <div class="upload-tip">最多上传9张，第一张为主图缩略图展示</div>
        </el-form-item>

        <!-- 产品视频 -->
        <el-form-item label="产品视频">
          <el-input v-model="currentData.video" placeholder="请输入视频URL地址" />
        </el-form-item>

        <!-- 产品标签 -->
        <el-form-item label="产品标签">
          <el-input v-model="currentData.tag" placeholder="如：热销、新品、推荐等" style="width: 300px;" />
        </el-form-item>

        <!-- 技术规格参数（可视化表单） -->
        <el-form-item label="技术规格">
          <div class="spec-editor">
            <!-- 规格分组列表 -->
            <div v-for="(group, gIndex) in specGroups" :key="gIndex" class="spec-group">
              <div class="spec-group-header">
                <el-input
                  v-model="group.group"
                  placeholder="规格分组名称，如：光学参数"
                  size="small"
                  style="width: 240px;"
                />
                <el-button
                  type="text"
                  icon="el-icon-plus"
                  style="margin-left: 10px;"
                  @click="addSpecItem(gIndex)"
                >添加参数</el-button>
                <el-button
                  type="text"
                  icon="el-icon-delete"
                  style="color: #f56c6c;"
                  @click="removeSpecGroup(gIndex)"
                >删除分组</el-button>
              </div>
              <!-- 参数列表 -->
              <div v-for="(item, iIndex) in group.items" :key="iIndex" class="spec-item">
                <el-input
                  v-model="item.name"
                  placeholder="参数名"
                  size="small"
                  style="width: 240px;"
                >
                  <template slot="prepend">参数名</template>
                </el-input>
                <span class="spec-colon">：</span>
                <el-input
                  v-model="item.value"
                  placeholder="参数值"
                  size="small"
                  style="flex: 1;"
                />
                <el-button
                  type="text"
                  icon="el-icon-close"
                  style="color: #f56c6c; margin-left: 6px;"
                  @click="removeSpecItem(gIndex, iIndex)"
                />
              </div>
            </div>
            <el-button
              type="primary"
              size="small"
              icon="el-icon-plus"
              plain
              @click="addSpecGroup"
            >添加规格分组</el-button>
          </div>
        </el-form-item>

        <!-- 规格书/附件 -->
        <el-form-item label="规格书/附件">
          <div class="upload-container">
            <upload
              :path="'product/spec'"
              :images="currentData.attachment ? currentData.attachment : ''"
              :multiple="false"
              :num="1"
              :accept="'.pdf,.doc,.docx,.xls,.xlsx,.zip,.rar'"
              @success="handleAttachmentSuccess"
              @remove="handleAttachmentRemove"
            />
          </div>
          <div class="upload-tip">支持 PDF、Word、Excel、压缩包格式</div>
        </el-form-item>

        <!-- 首页展示 -->
        <el-form-item label="首页展示">
          <el-switch
            v-model="currentData.is_home"
            :active-value="1"
            :inactive-value="0"
            active-color="#13ce66"
          />
          <span style="margin-left: 10px; color: #909399; font-size: 13px;">开启后将在官网首页展示</span>
        </el-form-item>

        <!-- 排序 -->
        <el-form-item label="排序">
          <el-input-number v-model="currentData.sort" :min="0" :max="9999" controls-position="right" />
          <span style="margin-left: 10px; font-size: 12px; color: #909399;">数值越小越靠前</span>
        </el-form-item>

        <!-- 内容 -->
        <el-form-item label="内容" required>
          <div class="rich-text-editor-container">
            <rich-text-editor
              v-model="currentData.content"
              :path="'product'"
              :placeholder="placeholders[currentData.language_code] || '请输入产品内容'"
              @change="handleContentChange"
            ></rich-text-editor>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表单操作 -->
    <div class="form-actions">
      <el-button @click="$emit('cancel')">取消</el-button>
      <el-button type="primary" @click="handleSubmit">保存</el-button>
    </div>
  </div>
</template>

<script>
import { getLanguage } from '@/api/public'
import RichTextEditor from '@/components/tool/RichTextEditor'
import Upload from '@/components/tool/lib/upload/index.vue'
import { getProductCategories, addProduct, updateProduct } from '@/api/website'

export default {
  name: 'AddProduct',
  components: {
    RichTextEditor,
    Upload
  },
  props: {
    product: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isDesktop: true,
      languageList: [],
      categoryList: [],
      specGroups: [], // 技术规格可视化编辑数据
      currentData: {
        name: '',
        sub_title: '',
        content: '',
        language_code: 'zh',
        category_id: '',
        image: '',
        images: '',
        video: '',
        tag: '',
        specifications: '',
        attachment: '',
        is_home: 0,
        sort: 0
      },
      placeholders: {
        zh: '请输入产品内容',
        en: 'Please enter product content',
        ko: '제품 내용을 입력하세요'
      }
    }
  },
  mounted() {
    this.checkScreenSize()
    window.addEventListener('resize', this.checkScreenSize)
    this.getLanguageList()
    this.getCategoryList()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize)
  },
  watch: {
    product: {
      handler(newProduct) {
        if (newProduct) {
          this.currentData = {
            id: newProduct.id,
            name: newProduct.name || '',
            sub_title: newProduct.sub_title || '',
            content: newProduct.content || '',
            language_code: newProduct.language_code || 'zh',
            category_id: newProduct.category_id || '',
            image: newProduct.image || '',
            images: newProduct.images || '',
            video: newProduct.video || '',
            tag: newProduct.tag || '',
            specifications: newProduct.specifications || '',
            attachment: newProduct.attachment || '',
            is_home: newProduct.is_home || 0,
            sort: newProduct.sort || 0
          }
          // 解析 JSON 规格数据为可视化表单
          this.parseSpecifications(newProduct.specifications)
        } else {
          this.resetForm()
        }
      },
      immediate: true
    }
  },
  methods: {
    getCategoryName(category) {
      if (!category.translations) return ''
      var lang = this.currentData.language_code || 'zh'
      if (category.translations[lang] && category.translations[lang].name) {
        return category.translations[lang].name
      }
      if (category.translations.zh && category.translations.zh.name) {
        return category.translations.zh.name
      }
      return ''
    },
    async getLanguageList() {
      try {
        const response = await getLanguage()
        this.languageList = response.data || []
      } catch (error) {
        console.error('获取语言列表失败:', error)
      }
    },
    checkScreenSize() {
      this.isDesktop = window.innerWidth > 768
    },
    resetForm() {
      this.currentData = {
        name: '',
        sub_title: '',
        content: '',
        language_code: 'zh',
        category_id: '',
        image: '',
        images: '',
        video: '',
        tag: '',
        specifications: '',
        attachment: '',
        is_home: 0,
        sort: 0
      }
      this.specGroups = []
    },
    handleImageSuccess(images) {
      this.currentData.image = images[0]
    },
    handleImageRemove(images) {
      this.currentData.image = images.length > 0 ? images[0] : ''
    },
    handleImagesSuccess(images) {
      this.currentData.images = images.join(',')
    },
    handleImagesRemove(images) {
      this.currentData.images = images.join(',')
    },
    getCategoryList() {
      getProductCategories().then(res => {
        this.categoryList = res.data || []
      })
    },
    handleContentChange(content) {
      this.currentData.content = content
    },
    // === 技术规格可视化编辑方法 ===
    parseSpecifications(jsonStr) {
      this.specGroups = []
      if (!jsonStr) return
      try {
        var parsed = typeof jsonStr === 'string' ? JSON.parse(jsonStr) : jsonStr
        if (Array.isArray(parsed)) {
          this.specGroups = parsed.map(function(g) {
            return {
              group: g.group || '',
              items: Array.isArray(g.items) ? g.items.map(function(item) {
                return { name: item.name || '', value: item.value || '' }
              }) : []
            }
          })
        }
      } catch (e) {
        console.warn('技术规格 JSON 解析失败:', e)
        this.specGroups = []
      }
    },
    addSpecGroup() {
      this.specGroups.push({ group: '', items: [{ name: '', value: '' }] })
    },
    removeSpecGroup(gIndex) {
      this.specGroups.splice(gIndex, 1)
    },
    addSpecItem(gIndex) {
      this.specGroups[gIndex].items.push({ name: '', value: '' })
    },
    removeSpecItem(gIndex, iIndex) {
      this.specGroups[gIndex].items.splice(iIndex, 1)
    },
    buildSpecificationsJson() {
      // 过滤掉空分组和空参数
      var valid = this.specGroups.filter(function(g) {
        return g.group.trim() !== '' || g.items.some(function(item) {
          return item.name.trim() !== '' || item.value.trim() !== ''
        })
      }).map(function(g) {
        return {
          group: g.group,
          items: g.items.filter(function(item) {
            return item.name.trim() !== '' || item.value.trim() !== ''
          }).map(function(item) {
            return { name: item.name, value: item.value }
          })
        }
      })
      return valid.length > 0 ? JSON.stringify(valid) : ''
    },
    // === 附件上传方法 ===
    handleAttachmentSuccess(images) {
      this.currentData.attachment = images[0]
    },
    handleAttachmentRemove(images) {
      this.currentData.attachment = images.length > 0 ? images[0] : ''
    },
    handleSubmit() {
      if (!this.currentData.language_code) {
        this.$message.error('请选择语言')
        return
      }
      if (!this.currentData.name) {
        this.$message.error('请输入产品名')
        return
      }
      if (!this.currentData.category_id) {
        this.$message.error('请选择品类')
        return
      }
      if (!this.currentData.image) {
        this.$message.error('请上传产品主图')
        return
      }
      if (!this.currentData.content) {
        this.$message.error('请输入产品内容')
        return
      }

      if (this.currentData.id) {
        // 编辑模式
        var editData = Object.assign({}, this.currentData)
        editData.specifications = this.buildSpecificationsJson()
        updateProduct(this.currentData.id, editData).then(res => {
          if (res.code === 200) {
            this.$emit('save', true)
          }
        })
      } else {
        // 新增模式
        var addData = Object.assign({}, this.currentData)
        addData.specifications = this.buildSpecificationsJson()
        addProduct(addData).then(res => {
          if (res.code === 200) {
            this.$emit('save', true)
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.add-product {
  box-sizing: border-box;
  padding: 0 20px;
}

.form-content {
  box-sizing: border-box;
  margin-bottom: 30px;
}

.upload-container {
  display: inline-block;
}

.upload-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

/* 技术规格编辑器 */
.spec-editor {
  width: 100%;
}

.spec-group {
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 12px;
  background-color: #fafafa;
}

.spec-group-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.spec-item {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.spec-colon {
  margin: 0 6px;
  color: #606266;
  flex-shrink: 0;
}

.rich-text-editor-container {
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  background-color: #f9f9f9;
  padding: 10px;
  min-height: 300px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #f0f2f5;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .add-product {
    padding: 10px 0;
  }

  .form-content {
    margin-bottom: 20px;
  }

  .rich-text-editor-container {
    min-height: 200px;
  }

  .form-actions {
    flex-direction: column;
  }

  .form-actions .el-button {
    width: 100%;
  }

  /* 富文本编辑器移动端样式 */
  .quill-editor {
    height: 150px;
  }

  .ql-toolbar.ql-snow {
    flex-wrap: wrap;
  }

  .ql-toolbar.ql-snow .ql-formats {
    margin-right: 10px;
    margin-bottom: 5px;
  }
}
</style>
